/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

if (isMobile || isTouchDevice) {
  body.classList.add("is-touch");
}

/*  ==========================================================================
		Setup utlities functions for cookies
		========================================================================== */

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
    GENERAL - add linklines to links
    ========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line--added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

    if (el.querySelector("img") < 1) {
      // &nbsp needed to keep the after / arrow icon on the same line as the last word
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line--added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

const sharingLinksInit = function () {
  const links = document.querySelector(".shareiconslist");

  if (!links) {
    return;
  }

  links.addEventListener("click", function (e) {
    e.preventDefault();
    const clicked = e.target.closest(".sharelink--popup");

    if (!clicked) {
      return;
    }

    const shareURL = clicked.getAttribute("href");
    window.open(shareURL, "share-dialog", "width=550,height=436");
  });
}; // sharingLinksInit();
sharingLinksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionInit = function () {
  const accordionItems = document.querySelectorAll(".tile--company--shortlist .tile__name");

  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(function (item) {
    item.addEventListener("click", function () {
      let shortlistTile = item.closest(".tile--company--shortlist");
      shortlistTile.classList.toggle("tile--company--shortlist--open");
      let panel = shortlistTile.querySelector(".tile__accordion");
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
    window.addEventListener("resize", function () {
      let shortlistTile = item.closest(".tile--company--shortlist");
      if (shortlistTile.classList.contains("tile--company--shortlist--open")) {
        let panel = shortlistTile.querySelector(".tile__accordion");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

  if (!plyrs) {
    return;
  }

  plyrs.forEach(function (el) {
    let plyrVideo = el.querySelector(".mediavideo__video");
    let plyr = new Plyr(plyrVideo, {
      controls: ["play-large", "play", "progress", "mute"],
      hideControls: true,
      invertTime: false,
      tooltips: { controls: false, seek: false }
    });
    // waiting for b&W poster to load before displaying
    setTimeout(function () {
      const container = el.querySelector(".plyr");
      if (container) {
        container.classList.add("plyr--ready");
      }
    }, 750);
  });
}; // plyrsInit();

plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(shareURL, "share-dialog", "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + "");
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Replace all star text with a highlight
  ========================================================================== */

const checkHighlight = function (elems) {
  if (elems.length) {
    elems.forEach(el => (el.innerHTML = el.innerHTML.replace(/(\*)(.*?)(\*)/g, "<span class='text-highlight'>$2</span>")));
  }
};

const highlightInit = function () {
  const textTags = document.querySelectorAll("p, h1, h2, h3, h4, h5, h6");
  if (textTags.length) {
    textTags.forEach(el => (el.innerHTML = el.innerHTML.replace(/(\*)(.*?)(\*)/g, "<span class='text-highlight'>$2</span>")));
  }
}; // highlight init

highlightInit();

/*  ==========================================================================
  GENERAL - Countdown Functionality
========================================================================== */

const enablecountdown = function () {
  const countdown_selector = document.querySelector(".pageheader__countdown");
  if (countdown_selector !== null) {
    var nowPrefix = new Date().getTime();

    // Step 2: Create a Date object from the timestamp
    var dateObject = new Date(nowPrefix);

    // Step 3: Format the Date object to a string with the desired locale and timezone
    var formattedDate = dateObject.toLocaleString("en-GB", { timeZone: "Europe/London" });

    // Step 4: Convert the formatted date string back into a Date object
    // Use the date and time parts from the formatted string to create a new Date object in local time
    var parts = formattedDate.split(/[\s,/:]+/);
    var day = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1; // Months are zero-based in JavaScript Date
    var year = parseInt(parts[2], 10);
    var hour = parseInt(parts[3], 10);
    var minute = parseInt(parts[4], 10);
    var second = parseInt(parts[5], 10);

    // Create a new Date object in the "Europe/London" timezone
    var londonDate = new Date(year, month, day, hour, minute, second);

    // Step 5: Get the Unix timestamp from the new Date object
    var unixTimestamp = londonDate.getTime();

    var countDownDate = new Date(php_variables.event_date.event_date.replace(/-/g, "/")).getTime().valueOf();

    var timeleft = countDownDate - unixTimestamp;

    var days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
    const days_span = document.querySelector(".countdown__days");
    const hours_span = document.querySelector(".countdown__hours");
    const minutes_span = document.querySelector(".countdown__minutes");
    const seconds_span = document.querySelector(".countdown__seconds");

    days_span.innerHTML = days < 10 ? `0${days}` : days;
    hours_span.innerHTML = hours < 10 ? `0${hours}` : hours;
    minutes_span.innerHTML = minutes < 10 ? `0${minutes}` : minutes;
    seconds_span.innerHTML = seconds < 10 ? `0${seconds}` : seconds;
    $(".pageheader__countdownwrap").css("opacity", "1");
  }
};

window.setInterval(function () {
  enablecountdown();
}, 1);

/*  ==========================================================================
    AJAX - Setup Variables
    ========================================================================== */

const filters = document.querySelector(".filters"),
  filtersForm = document.querySelector(".filters__form"),
  filtersToggles = document.querySelectorAll(".filters__bar__item--withdropdown .filters__bar__title"),
  closeFilter = document.querySelectorAll(".close__filter"),
  filtersSearch = document.querySelector(".filters__searchdropdown__wrap"),
  filtersDropdowns = document.querySelectorAll(".filters__bar__dropdown"),
  filterSearchToggle = document.querySelector(".filters__bar__item--search .filters__bar__title"),
  filterSearch = document.querySelector(".filters__searchdropdown"),
  filterSearchInput = document.querySelector(".filters__searchdropdown input"),
  filterTags = document.querySelector(".filtertags");

let maxPage = php_variables.max_page;
let filtersInitialLoad = true;
let activeTagsNotEmpty = false;
let searchData = false;

/*  ==========================================================================
      AJAX - Go to previous scroll position
      ========================================================================== */

const scrollToCorrectPos = function () {
  let lastScroll = localStorage.getItem("scrollPosition" + php_variables.page_id);
  let previousScrollURL = localStorage.getItem("previousScrollURL" + php_variables.page_id);
  // If there is a stored scroll position and current filter matches the previous filter url, go to scroll position
  if (lastScroll && lastScroll !== "0" && lastScroll !== 0 && previousScrollURL && previousScrollURL === window.location.href) {
    window.scroll({
      top: parseInt(localStorage.getItem("scrollPosition" + php_variables.page_id), 10),
      behavior: "instant"
    });
  } else {
    // If not then go pin user to the filters
    window.scroll({
      top: document.querySelector(".filters-pin").offsetTop - document.querySelector(".siteheader").clientHeight,
      behavior: "instant"
    });
  }
};

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);
    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.textContent; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page,
        query_string: location.search,
        demo: php_variables.demo_day
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.textContent = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(maxPage)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // re-init demo day (e.g. button clicks etc)
      setupSavedBtns();
      setupCompanyLinks();

      // refresh waypoints
      Waypoint.refreshAll();

      scrollToCorrectPos();
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page

  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page,
    query_string: location.search,
    demo: php_variables.demo_day
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(maxPage)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(maxPage)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);

        // re-init demo day (e.g. button clicks etc)
        setupSavedBtns();
        setupCompanyLinks();

        // refresh waypoints
        Waypoint.refreshAll();
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

let p = 1;
const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }

  /** When adding fitering you will need to move this part into the filtering call */
  // if (p == 1) {
  // p += 1;
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > maxPage ? maxPage : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  // }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    let scrollPosition = window.scrollY;
    localStorage.setItem("scrollPosition" + php_variables.page_id, scrollPosition);
    localStorage.setItem("previousScrollURL" + php_variables.page_id, window.location.href);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
        AJAX - AJAX Companies filter
        ========================================================================== */

// Get current from filters data
const filterGetFormData = function () {
  let filter_data = {};

  filter_settings.filters.forEach(function (el) {
    let checkedOptions = document.querySelectorAll('input[type="checkbox"][name=' + el.name + "]:checked");

    if (checkedOptions.length > 0) {
      filter_data[el.name] = [...checkedOptions].map(x => x.value);
    }
  });

  return filter_data;
};

// Update the url to match the active filters
const filterUpdateURL = function (filterData, searchData) {
  let url_params = "";

  for (const [key, value] of Object.entries(filterData)) {
    if (value.length > 0) {
      if (url_params === "") {
        url_params = url_params + "?";
      } else {
        url_params = url_params + "&";
      }
      // Convert values to comma seperated string
      let values = Object.keys(value)
        .map(function (k) {
          return value[k];
        })
        .join(",");
      url_params = url_params + "filter-" + key + "=" + values;
    }
  }

  if (searchData) {
    if (url_params === "") {
      url_params = url_params + "?";
    } else {
      url_params = url_params + "&";
    }
    url_params = url_params + "search=" + searchData;
  }

  let currentPageUrl = window.location.href.split("?")[0];
  let newUrl = currentPageUrl + url_params;
  window.history.pushState({ path: newUrl }, "", newUrl);
};

// Setup up the Active Filters in the Tags section and Active States for filtersets
const filterDisplayActiveFilters = function (filterData) {
  let hasClassActive = false;
  // Reset styles
  const fieldsets = document.querySelectorAll(".filters__fieldset");
  fieldsets.forEach(set => {
    set.classList.remove("filters__fieldset--active");
  });

  const toggleBtns = document.querySelectorAll(".filters__toggle");
  toggleBtns.forEach(btn => {
    btn.classList.remove("filters__toggle--active");
  });

  // Reset tags
  if (filterTags) {
    filterTags.classList.remove("filtertags--active");
    document.querySelector(".filtertags__activetags__tags").innerHTML = "";
  }

  for (const [key, values] of Object.entries(filterData)) {
    if (values.length > 0) {
      // Make field group active
      document.querySelector(".filters__fieldset[data-value='" + key + "']").classList.add("filters__fieldset--active");

      // Show active tags
      if (filterTags) {
        filterTags.classList.add("filtertags--active");
      }

      let activeToggleBtns = document.querySelectorAll(".filters__toggle[href='#" + key + "']");

      activeToggleBtns.forEach(btn => {
        btn.classList.add("filters__toggle--active");
      });

      for (const value of values) {
        // Make input field active
        let filter_input = document.querySelector("input[name='" + key + "'][value='" + value + "']").closest(".filters__fieldset__field");

        // Add tag
        let filter_input_name = filter_input.querySelector(".filters__fieldset__field__label").innerHTML;

        document.querySelector(".filtertags__activetags__tags").innerHTML += `<div class="filters__tag" data-name="${key}" data-value="${value}">${filter_input_name} </div>`;

        hasClassActive = true;
      }
    }
  }

  if (searchData) {
    if (filterTags) {
      filterTags.classList.add("filtertags--active");
    }
    document.querySelector(".filtertags__activetags__tags").innerHTML += `<div class="filters__tag filters__tag--search" data-name="search" data-value="search">${searchData} </div>`;
  }

  return hasClassActive;
};

const filterGetPosts = function (updateURL) {
  // Getting the forma data
  let filterData = filterGetFormData();
  let pageData = false;

  if (filterSearch && filterSearchInput) {
    searchData = filterSearchInput.value;
  }

  // close search
  filterSearch.classList.remove("filters__searchdropdown--open");
  filterSearchToggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");

  let currentPageInput = document.querySelector("input.filters__currentpage");
  let currentPageNum = false;

  if (currentPageInput) {
    currentPageNum = currentPageInput.value;
  }

  if (filterData || searchData) {
    // Update url
    if (updateURL) {
      filterUpdateURL(filterData, searchData);

      // reseting current page
      if (currentPageInput) {
        currentPageNum = 1;
        currentPageInput.value = 1;
      }
    }

    let activeTagsNotEmpty = filterDisplayActiveFilters(filterData, searchData);

    if ((filtersInitialLoad && (activeTagsNotEmpty || searchData !== "" || currentPageNum !== "1")) || !filtersInitialLoad) {
      // Start filtering
      loadmoreContainer.classList.add("filtering");

      filtersInitialLoad = false;

      filter_settings.querystring = window.location.search;

      // Trigger ajax
      let data = {
        action: "filter",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function in enqueue-scripts.php
        page: php_variables.current_page,
        filter_settings: filter_settings, // passed in via wp_localize_script in filters.php
        filter_data: filterData,
        search_data: searchData
      };

      $.ajax({
        url: php_variables.ajax_url,
        data: data, // form data
        dataType: "json", // this data type allows us to receive objects from the server
        type: "POST",
        success: function (data) {
          // when filter applied:
          // set the current page to 1
          php_variables.current_page = 1;

          // set the new query parameters
          php_variables.posts = data.posts;

          // set the new max page parameter
          maxPage = data.max_page;

          // hide load more button, if there are not enough posts for the second page
          if (loadmoreBtn) {
            if (data.max_page < 2) {
              loadmoreBtn.style.display = "none";
            } else {
              loadmoreBtn.style.display = "block";
            }
          }

          // insert the posts to the container
          const loadmoreContainer = document.querySelector(".companies.loadmore-container");
          if (loadmoreContainer) {
            loadmoreContainer.innerHTML = data.content;
          }

          setFilterTagsListeners();

          lazyLoadInstance.update();

          const effects = document.querySelectorAll(".effect");
          effectsInit(effects);

          // re-init demo day (e.g. button clicks etc)
          setupSavedBtns();
          setupCompanyLinks();

          // refresh waypoints
          Waypoint.refreshAll();

          // If there is more than one page that needs to be loaded
          if (currentPageNum && currentPageNum > 1) {
            currentPageNum = currentPageNum > data.max_page ? data.max_page : currentPageNum;
            loadmoreLoadPostsMultiplePages(currentPageNum);
          } else {
            scrollToCorrectPos();
          }

          loadmoreContainer.classList.remove("filtering");
        },
        error: function (data) {}
      });
    }
  }
};

const setFilterTagsListeners = function () {
  const allFilterTags = document.querySelectorAll(".filters__tag");
  allFilterTags.forEach(tag => {
    tag.addEventListener("click", function () {
      let filter_name = tag.dataset.name;
      let filter_value = tag.dataset.value;
      if (filter_name === "search") {
        // empty search input
        filterSearchInput.value = "";
      } else {
        // Clear filter tag
        let filter_input = (document.querySelector("input[name='" + filter_name + "'][value='" + filter_value + "']").checked = false);
      }

      // Remove tag
      tag.remove();
      // Trigger filter
      filterGetPosts(true);
    });
  });
};

const filterSetupClearAll = function () {
  const filterClearAll = document.querySelectorAll(".filtertags__clearall");
  filterClearAll.forEach(btn => {
    btn.addEventListener("click", function () {
      // Clear search
      if (filterSearch && filterSearchInput) {
        filterSearchInput.value = "";
        filterSearch.classList.remove("filters__searchdropdown--open");
        filterSearchToggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
      }

      // Remove all tags
      document.querySelector(".filtertags").classList.remove("filtertags--active");
      document.querySelector(".filtertags__activetags__tags").innerHTML = "";

      // Uncheck all inputs
      const filterCheckboxes = document.querySelectorAll(".filters__fieldset__field input");
      filterCheckboxes.forEach(el => (el.checked = false));

      // Trigger filter & reset scroll position to stop is scrolling to weird places
      localStorage.setItem("scrollPosition" + php_variables.page_id, 0);
      filterGetPosts(true);
      filters.classList.remove("filters--searchopen");

      filtersToggles.forEach(toggle => {
        toggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
      });
    });
  });
};

// INIT FILTER
const filterInit = function () {
  if (filtersForm && filtersForm.length) {
    // Get Posts based on Filter Form Data
    filterGetPosts(false);

    // Dropdowns open & close
    // close dropdown when clicking anywhere else on page
    window.addEventListener("click", function (e) {
      let openDropdown = document.querySelector(".filters__bar__item--open");
      if (openDropdown) {
        if (!(openDropdown.contains(e.target) || openDropdown.querySelector(".filters__bar__dropdown").contains(e.target))) {
          // Clicked outside the dropdown box
          openDropdown.classList.remove("filters__bar__item--open");
        }
      }
    });

    // Store original titles
    let filter__titles = [];
    // open on toggles
    filtersToggles.forEach(toggle => {
      // Populate original titles
      const previousContent = toggle.closest(".filters__bar__title").textContent;
      filter__titles.push(previousContent);

      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.closest(".filters__bar__item").classList.contains("filters__bar__item--open")) {
          this.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
          this.closest(".filters__bar__title").innerHTML = "filters__bar__item--open";
          this.closest(".filters__bar__title").innerHTML = previousContent;
        } else {
          // Close search & other dropdowns
          filterSearch.classList.remove("filters__searchdropdown--open");
          filterSearchToggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
          filtersToggles.forEach((toggle, key) => {
            toggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
            toggle.closest(".filters__bar__title").innerHTML = filter__titles[key];
          });
          // open this dropdown
          this.closest(".filters__bar__item").classList.add("filters__bar__item--open");
          if (window.innerWidth < 1000) {
            this.closest(".filters__bar__title").innerHTML = "close";
          } else {
            this.closest(".filters__bar__title").innerHTML = previousContent;
          }
        }
      });
    });
    // open on toggles
    closeFilter.forEach(toggle => {
      // Populate original titles
      // const previousContent = toggle.target;
      // console.log(previousContent);

      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        // const getParent = e.target.closest(".filters__bar__item");

        if (this.closest(".filters__bar__item").classList.contains("filters__bar__item--open")) {
          this.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
          this.closest(".filters__bar__title").innerHTML = "filters__bar__item--open";
          this.closest(".filters__bar__title").innerHTML = previousContent;
        } else {
          // Close search & other dropdowns
          filterSearch.classList.remove("filters__searchdropdown--open");
          filterSearchToggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
          filtersToggles.forEach((toggle, key) => {
            toggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
            toggle.closest(".filters__bar__title").innerHTML = filter__titles[key];
          });
          // open this dropdown
          this.closest(".filters__bar__item").classList.add("filters__bar__item--open");
          if (window.innerWidth < 1000) {
            this.closest(".filters__bar__title").innerHTML = "close";
          } else {
            this.closest(".filters__bar__title").innerHTML = previousContent;
          }
        }
      });
    });

    // On clicking of the mobile search, reset the dropdowns
    filtersSearch.addEventListener("click", function (e) {
      filtersToggles.forEach((toggle, key) => {
        toggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
        toggle.closest(".filters__bar__title").innerHTML = filter__titles[key];
      });
    });

    // Search open & close
    filterSearchToggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (filterSearch.classList.contains("filters__searchdropdown--open")) {
        filterSearch.classList.remove("filters__searchdropdown--open");
        filterSearchToggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
        // trigger search on close
        filterGetPosts(true);
      } else {
        // close other dropdowns
        filtersToggles.forEach((toggle, key) => {
          toggle.closest(".filters__bar__item").classList.remove("filters__bar__item--open");
        });
        // open search
        filterSearchToggle.closest(".filters__bar__item").classList.add("filters__bar__item--open");
        filterSearch.classList.add("filters__searchdropdown--open");
        filterSearch.querySelector("input").focus();
      }
    });

    document.addEventListener(
      "click",
      function (event) {
        // If user either clicks outside the modal window, then close modal by calling closeModal()
        if (filters.classList.contains("filters--dropdownopen") && !event.target.closest(".filters")) {
          filters.classList.remove("filters--dropdownopen");
          filtersToggle.forEach(item => {
            item.classList.remove("active");
          });
        }
      },
      false
    );

    // Filter on submit
    filtersForm.addEventListener("submit", function (e) {
      // Stop the form from submitting
      e.preventDefault();

      // Call the filtering post function
      filterGetPosts(true);
      filters.classList.remove("filters--dropdownopen");
    });

    const filterCheckboxes = filtersForm.querySelectorAll(".filters__fieldset__field input");

    filterCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", function (evt) {
        // Submit for on checkbox click
        filterGetPosts(true);
      });
    });

    // Remove tags on click
    setFilterTagsListeners();

    // Clear all
    filterSetupClearAll();
  }
};

filterInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Logo Scroll on Homepage
    ========================================================================== */

function positionLogo() {
  const logo = document.querySelector(".siteheader .siteheader__logo");

  // Scroll start and end points
  const scroll_end_point = document.querySelector(".logopadder").clientHeight;
  const scroll_start_point = document.querySelector(".logopadder").clientHeight * 0.3;

  const transform_start_size = 100; // needs to match css
  const transform_end_size = 0;

  const width_start_size = 100;
  let translateX = 0;
  let width_end_size = 50; // Needs to match CSS % width on other pages
  if (window.innerWidth > 1000) {
    width_end_size = 30; // Needs to match CSS % width on other pages
    translateX = 50;
  }
  if (window.innerWidth > 1600) {
    width_end_size = 22; // Needs to match CSS % width on other pages
  }
  // Animate the transform and top positions between the scroll_start_point and scroll_end_point - half of the time the width animates
  if (window.scrollY < scroll_start_point && window.innerWidth > 1000) {
    logo.style.transform = "translate(-" + translateX + "%, -" + transform_start_size + "%)";
  } else if (window.scrollY > scroll_start_point && window.scrollY < scroll_end_point && window.innerWidth > 1000) {
    let scroll_percentage = 1 - (window.scrollY - scroll_start_point) / (scroll_end_point - scroll_start_point);
    let transform_scaling_size = (transform_start_size - transform_end_size) * scroll_percentage + transform_end_size;
    logo.style.transform = "translate(-" + translateX + "%, -" + transform_scaling_size + "%)";
  } else {
    logo.style.transform = "translate(-" + translateX + "%, -" + transform_end_size + "%)";
  }
  // Animate the width between the first scroll and scroll_end_point
  if (window.scrollY < scroll_end_point && window.innerWidth > 1000) {
    let scroll_percentage = 1 - window.scrollY / scroll_end_point;
    let width_scaling_size = (width_start_size - width_end_size) * scroll_percentage + width_end_size;
    logo.style.width = width_scaling_size + "%";
  } else {
    logo.style.width = width_end_size + "%";
  }
}

// if is homepage and has logo padder trigger animation
if (document.querySelectorAll(".logopadder").length && document.querySelectorAll(".home").length) {
  window.addEventListener("resize", function () {
    positionLogo();
  });
  window.addEventListener("scroll", function () {
    positionLogo();
  });
}

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarouselInit = function () {
  const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    const mouseDrag = elem.dataset.mousedrag ? elem.dataset.mousedrag : false;
    const touchDrag = elem.dataset.touchdrag ? elem.dataset.touchdrag : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoheight && elem.dataset.autoheight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      mouseDrag: mouseDrag,
      touchDrag: touchDrag,
      items: 1,
      navText: ["<div class='owl-nav__icon'></div>", "<div class='owl-nav__icon'></div>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit();

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
  DEMO DAY - Setup variables
========================================================================== */

// Setup constants
const shortlistBar = document.querySelector(".shortlistbar");
const shortlistConfirmation = document.querySelector(".shortlistconfirmation");
const shortlistContinue = shortlistConfirmation ? shortlistConfirmation.querySelector(".shortlistconfirmation__continuebtn") : false;
const shortlistIntroduce = shortlistConfirmation ? shortlistConfirmation.querySelector(".shortlistconfirmation__introducebtn") : false;
const shortlistConfirmationClose = shortlistConfirmation ? shortlistConfirmation.querySelector(".shortlistconfirmation__close") : false;
const shortlistConfirmationOverlay = shortlistConfirmation ? shortlistConfirmation.querySelector(".shortlistconfirmation__overlay") : false;
const introForm = document.querySelector(".introductionform");
const introFormContinueBtns = introForm ? introForm.querySelectorAll(".introductionform__form__continuebtn") : false;
const companyOverlay = document.querySelector(".companyoverlay");
const companyOverlayBG = document.querySelector(".companyoverlay__bg");

/*  ==========================================================================
  DEMO DAY - General functions
========================================================================== */

// set a button to "saved"
function setBtn(companyID, setTo = "saved") {
  let companyBtns = document.querySelectorAll(".save-company[data-companyid='" + companyID + "']");
  if (companyBtns) {
    companyBtns.forEach(function (companyBtn) {
      if (setTo === "saved") {
        companyBtn.classList.add("saved");
        companyBtn.innerHTML = "Shortlisted";
      } else if (setTo === "introduced") {
        companyBtn.classList.add("introduced");
        let companySlideout = document.querySelector(".company[data-companyid='" + companyID + "']");
        if (companySlideout) {
          // if slide out is open as add a class to this to disabled the "introduce me" button
          companySlideout.classList.add("company--introduced");
        }
        if (php_variables.demo_day_access_type === "private") {
          companyBtn.innerHTML = "Introduced";
        } else {
          companyBtn.innerHTML = "Intro Requested";
        }
      }
    });
  }
}

/*  ==========================================================================
  DEMO DAY - Reset saved buttons
========================================================================== */

function resetSavedBtns() {
  let savedBtns = document.querySelectorAll(".save-company.saved");
  if (savedBtns) {
    savedBtns.forEach(function (saveBtn) {
      saveBtn.classList.remove("saved");
      saveBtn.innerHTML = "Add to shortlist";
    });
  }
}

/*  ==========================================================================
  DEMO DAY - Shortlist bar functions
========================================================================== */

// update shortlist bar
function updateShortlistBar() {
  // Get current shortlist
  let demodayID = php_variables.demo_day.ID;
  if (demodayID) {
    let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
    let currentShortlistArray = [];
    if (currentShortlist) {
      currentShortlistArray = currentShortlist.split(",");
      if (currentShortlistArray.length !== 0) {
        // There are shortlisted companies
        // Update count in shortlist bar
        shortlistBar.querySelector(".shortlistbar__count").innerHTML = "(" + String(currentShortlistArray.length).padStart(2, "0") + ")";
        // Show the bar (in toggle format)
        shortlistBar.classList.add("shortlistbar--open");
      } else {
        // Hide the bar
        shortlistBar.classList.remove("shortlistbar--open");
      }
    } else {
      // Hide the bar
      shortlistBar.classList.remove("shortlistbar--open");
    }
  }
}

/*  ==========================================================================
  DEMO DAY - Shortlist confirmation functions
========================================================================== */

// update shortlist confirmation
function showShortlistConfirmation(companyID) {
  // Get current shortlist
  let demodayID = php_variables.demo_day.ID;
  if (demodayID && companyID) {
    // Trigger AJAX to update confirmation content
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: {
        action: "getconfirmationhtml",
        demo: demodayID,
        company: companyID
      },
      type: "POST",
      beforeSend: function (xhr) {},
      success: function (data) {
        if (data) {
          shortlistConfirmation.querySelector(".shortlistconfirmation__company").innerHTML = data;
          shortlistConfirmation.classList.add("shortlistconfirmation--open");
        }
      }
    });
  }
}

function closeShortlistConfirmation() {
  shortlistConfirmation.classList.remove("shortlistconfirmation--open");
}

/*  ==========================================================================
  DEMO DAY - Introduction form functions
========================================================================== */

// Show intro form
function showIntroductionForm() {
  // Get current shortlist
  let demodayID = php_variables.demo_day.ID;
  if (demodayID) {
    let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
    let currentShortlistArray = [];
    if (currentShortlist) {
      currentShortlistArray = currentShortlist.split(",");
      if (currentShortlistArray.length !== 0) {
        // There are shortlisted companies
        // Trigger AJAX to update shortlist content before form
        $.ajax({
          url: php_variables.ajax_url, // AJAX handler
          data: {
            action: "getintroductioncompanyinfo",
            demo: php_variables.demo_day.ID
          },
          type: "POST",
          beforeSend: function (xhr) {},
          success: function (data) {
            if (data) {
              var responseArray = JSON.parse(data);
              var fullUrl = document.location.href;
              var baseUrl = fullUrl.indexOf("?") !== -1 ? fullUrl.substring(0, fullUrl.indexOf("?")) : fullUrl;
              if (responseArray.list_html) {
                introForm.querySelector(".introductionform__companies__list").innerHTML = responseArray.list_html;
              }
              if (responseArray.ids) {
                // update ninja form field
                if ($("#nf-form-4-cont").length) {
                  // private intro form
                  $("#nf-field-51").val(responseArray.ids).trigger("change");
                } else {
                  // public intro form
                  $("#nf-field-45").val(responseArray.ids).trigger("change");
                }
              }
              if (responseArray.custom_ids) {
                // update ninja form field
                if ($("#nf-form-4-cont").length) {
                  // private intro form
                  $("#nf-field-54").val(responseArray.custom_ids).trigger("change");
                } else {
                  // public intro form
                  $("#nf-field-53").val(responseArray.custom_ids).trigger("change");
                }
              }
              if (responseArray.date) {
                // update ninja form field
                if ($("#nf-form-4-cont").length) {
                  // private intro form
                  $("#nf-field-52").val(responseArray.date).trigger("change");
                } else {
                  // public intro form
                  $("#nf-field-47").val(responseArray.date).trigger("change");
                }
              }
              if (responseArray.demoday_slug) {
                // update ninja form field
                if ($("#nf-form-4-cont").length) {
                  // private intro form
                  $("#nf-field-41").val(responseArray.demoday_slug).trigger("change");
                  $("#nf-field-68").val(baseUrl).trigger("change");
                } else {
                  // public intro form
                  $("#nf-field-50").val(responseArray.demoday_slug).trigger("change");
                  $("#nf-field-69").val(baseUrl).trigger("change");
                }
              }
              // Show the form
              body.classList.add("introductionformisopen");
              introForm.classList.add("introductionform--open");
              // Reinit accordions
              accordionInit();
              // set click on delete
              setupDeleteBtns();
            }
          }
        });
      }
    }
  }
}

// close introduction form
function closeIntroductionForm() {
  body.classList.remove("introductionformisopen");
  introForm.classList.remove("introductionform--open");
  closeShortlistConfirmation();
  updateShortlistBar();
  setupSavedBtns();
}

/*  ==========================================================================
  DEMO DAY - Company Slide Out
========================================================================== */

let companyRequest;
let companyTimeout;

function openCompany(companySlug, index, count) {
  if (companySlug) {
    // abort any existing ajax requests
    clearTimeout(companyTimeout);
    if (companyRequest) {
      companyRequest.abort();
    }
    // start new one
    let openTimeout = 0;
    if (body.classList.contains("companyoverlayisopen")) {
      // slide out the company
      companyOverlay.classList.remove("companyoverlay--open");
      //companyOverlay.classList.add("companyoverlay--closing");
      setTimeout(function () {
        // then remove the overlay and the content in the slide out
        companyOverlay.querySelector(".companyoverlay__wrap__inner").innerHTML = "";
        //companyOverlay.classList.remove("companyoverlay--closing");
      }, 250);
      openTimeout = 250;
    }
    companyTimeout = setTimeout(function () {
      // open overlay
      body.classList.add("companyoverlayisopen");
      // Load company data
      let demodayID = php_variables.demo_day.ID;
      companyRequest = $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: {
          action: "getcompany",
          demo: demodayID,
          company: companySlug,
          index: index,
          count: count
        },
        type: "POST",
        beforeSend: function (xhr) {},
        success: function (data) {
          if (data) {
            // Open slide out
            companyOverlay.classList.add("companyoverlay--open");
            companyOverlay.querySelector(".companyoverlay__wrap__inner").innerHTML = data;
            // update URL
            let url = new URL(window.location.href);
            if (url.searchParams.has("company")) {
              if (url.searchParams.has("company") !== companySlug) {
                url.searchParams.set("company", companySlug);
              }
            } else {
              url.searchParams.append("company", companySlug);
            }

            window.history.pushState({}, "", url);
            // Re-init lazy load
            lazyLoadInstance.update(); // reinit lazy load after ajax
            // Re-init plyr
            plyrsInit();
            // Re-init links
            linksInit();
            // Re-init carousels
            gridCarouselInit();
            // re-init demo day (e.g. button clicks etc)
            setupSavedBtns();
            setupCompanyLinks();
            // setup close button
            const companyOverlayClose = document.querySelector(".companyoverlay__close");
            companyOverlayClose.addEventListener("click", function (e) {
              e.preventDefault();
              closeCompany();
            });
            // Setup introduce me button
            const companyIntroduce = document.querySelector(".introduce-me");
            let companyID = companyIntroduce.dataset.companyid;
            companyIntroduce.addEventListener("click", function (e) {
              e.preventDefault();
              // Get current shortlist
              let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
              let currentShortlistArray = [];
              if (currentShortlist) {
                currentShortlistArray = currentShortlist.split(",");
              }
              // add this company to shortlist
              if (!currentShortlistArray.includes(companyID)) {
                currentShortlistArray.push(companyID);
              }
              // set the cookie
              setCookie("shortlisted_companies_" + demodayID, currentShortlistArray.join(","), 7);
              // Close company popup
              closeCompany(true);
              // Open introduction form
              showIntroductionForm();
              window.history.pushState({}, "", window.location.search);
            });
          }
        }
      });
    }, openTimeout);
  }
}

function closeCompany(keepCompanyString = false) {
  // abort any ajax requests
  clearTimeout(companyTimeout);
  if (companyRequest) {
    companyRequest.abort();
  }
  // slide out the company
  companyOverlay.classList.remove("companyoverlay--open");
  setTimeout(function () {
    // then remove the overlay and the content in the slide out
    companyOverlay.querySelector(".companyoverlay__wrap__inner").innerHTML = "";
    body.classList.remove("companyoverlayisopen");
    // Remove URL
    let url = new URL(window.location.href);
    if (url.searchParams.has("company") && keepCompanyString === false) {
      url.searchParams.delete("company");
      let newurl = url.toString();
      // update URL
      window.history.pushState({}, "", newurl);
    }
  }, 250);
}

/*  ==========================================================================
  DEMO DAY - Save Buttons
========================================================================== */

function setupSavedBtns() {
  const saveBtns = document.querySelectorAll(".save-company");
  if (saveBtns) {
    // Setup save button event listeners
    saveBtns.forEach(function (saveBtn) {
      // Check for saved already and update buttons
      let demodayID = php_variables.demo_day.ID;
      if (demodayID) {
        let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
        let currentShortlistArray = [];
        if (currentShortlist) {
          currentShortlistArray = currentShortlist.split(",");
          if (currentShortlistArray !== 0) {
            currentShortlistArray.forEach(function (shortlistedCompany) {
              setBtn(shortlistedCompany, "saved");
            });
          } else {
            // Remove save class as shortlist is empty
            resetSavedBtns();
          }
        } else {
          // Remove save class as shortlist is empty
          resetSavedBtns();
        }
      }

      // Check for introduced already and update buttons
      if (demodayID) {
        let currentIntroduced = getCookie("introduced_companies_" + demodayID);
        let currentIntroducedArray = [];
        if (currentIntroduced) {
          currentIntroducedArray = decodeURIComponent(currentIntroduced).split(",");
          if (currentIntroducedArray !== 0) {
            currentIntroducedArray.forEach(function (introducedCompany) {
              setBtn(introducedCompany, "introduced");
            });
          }
        }
      }

      // Setup save button event listener
      if (!saveBtn.classList.contains("initialized")) {
        saveBtn.classList.add("initialized");
        saveBtn.addEventListener("click", function (e) {
          // e.preventDefault();

          let companyID = saveBtn.dataset.companyid;
          let demodayID = php_variables.demo_day.ID;
          // Get current shortlist
          let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
          let currentShortlistArray = [];
          if (currentShortlist) {
            currentShortlistArray = currentShortlist.split(",");
          }
          // add this company to shortlist
          if (!currentShortlistArray.includes(companyID)) {
            currentShortlistArray.push(companyID);
          }
          // Close company popup
          closeCompany();
          // show shortlist confirmation
          // Change button to "add to shortlist"
          if (e.target.classList.contains("saved")) {
            removeCompany(companyID, demodayID);
            let companyBtns = document.querySelectorAll(".save-company[data-companyid='" + companyID + "']");
            if (companyBtns) {
              companyBtns.forEach(function (companyBtn) {
                companyBtn.classList.remove("saved");
                companyBtn.innerHTML = "Add to Shortlist";
              });
            }
            // Change button to "saved"
          } else {
            // set the cookie
            setCookie("shortlisted_companies_" + demodayID, currentShortlistArray.join(","), 7);
            showShortlistConfirmation(companyID);
            setBtn(companyID, "saved");
          }
          // setBtn(companyID, "saved");
          // Update shortlist popup
          updateShortlistBar();
        });
      }
    });
  }
}

/*  ==========================================================================
  DEMO DAY - Delete Buttons
========================================================================== */

function removeCompany(companyID, demodayID) {
  let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
  let currentShortlistArray = [];
  if (currentShortlist) {
    currentShortlistArray = currentShortlist.split(",");
  }
  // remove this company from shortlist
  const index = currentShortlistArray.indexOf(companyID);
  if (index > -1) {
    // only splice array when item is found
    currentShortlistArray.splice(index, 1); // 2nd parameter means remove one item only
  }
  setCookie("shortlisted_companies_" + demodayID, currentShortlistArray.join(","), 7);
}

/*  ==========================================================================
  DEMO DAY - Delete Buttons
========================================================================== */

function setupDeleteBtns() {
  const deleteBtns = document.querySelectorAll(".tile--company--shortlist .tile__delete");
  if (deleteBtns) {
    deleteBtns.forEach(function (deleteBtn) {
      deleteBtn.addEventListener("click", function (e) {
        e.preventDefault();
        let companyID = deleteBtn.dataset.companyid;
        let demodayID = php_variables.demo_day.ID;
        // Get current shortlist
        let currentShortlist = getCookie("shortlisted_companies_" + demodayID);
        let currentShortlistArray = [];
        if (currentShortlist) {
          currentShortlistArray = currentShortlist.split(",");
        }
        // remove this company from shortlist
        const index = currentShortlistArray.indexOf(companyID);
        if (index > -1) {
          // only splice array when item is found
          currentShortlistArray.splice(index, 1); // 2nd parameter means remove one item only
        }
        // reset the cookie
        setCookie("shortlisted_companies_" + demodayID, currentShortlistArray.join(","), 7);
        // Remove from list
        deleteBtn.closest(".tile--company--shortlist").remove();
        // check if array is now empty
        if (currentShortlistArray === undefined || currentShortlistArray.length === 0) {
          closeIntroductionForm();
        } else {
          showIntroductionForm(); // update intro form (e.g. values in ninja form)
        }
      });
    });
  }
}

/*  ==========================================================================
  DEMO DAY - Company Links
========================================================================== */

function setupCompanyLinks() {
  const companyLinks = document.querySelectorAll(".tile--company .tile__link, .tile--company .tile__link--alt");

  if (companyLinks) {
    companyLinks.forEach(function (companyLink) {
      companyLink.addEventListener("click", function (e) {
        e.preventDefault();
        let companySlug = companyLink.dataset.companyslug;
        let companyIndex = companyLink.dataset.index;
        let companyCount = companyLink.dataset.count;
        openCompany(companySlug, companyIndex, companyCount);
      });
    });
  }
}

/*  ==========================================================================
  DEMO DAY - Init everything!
========================================================================== */

function initDemoDay() {
  if (!shortlistBar) {
    return;
  }

  // Setup button click events
  shortlistConfirmationOverlay.addEventListener("click", function () {
    closeShortlistConfirmation();
  });
  shortlistConfirmationClose.addEventListener("click", function () {
    closeShortlistConfirmation();
  });
  shortlistContinue.addEventListener("click", function (e) {
    e.preventDefault();
    closeShortlistConfirmation();
  });
  shortlistIntroduce.addEventListener("click", function (e) {
    e.preventDefault();
    showIntroductionForm();
  });
  introFormContinueBtns.forEach(function (introFormContinue) {
    introFormContinue.addEventListener("click", function (e) {
      e.preventDefault();
      closeIntroductionForm();
    });
  });
  companyOverlayBG.addEventListener("click", function (e) {
    e.preventDefault();
    closeCompany();
  });

  // setup shortlist bar
  updateShortlistBar();
  shortlistBar.addEventListener("click", function (e) {
    e.preventDefault();
    showIntroductionForm();
  });

  // Setup saved buttons
  setupSavedBtns();

  // Setup company links
  setupCompanyLinks();

  // Check for company URL
  let url = new URL(window.location.href);
  if (url.searchParams.has("company")) {
    let urlCompany = url.searchParams.get("company");
    openCompany(urlCompany);
  }
}

initDemoDay();

/*  ==========================================================================
  DEMO DAY - Update access form field
========================================================================== */

// Add current url to hidden field in access form
jQuery(document).on("nfFormReady", function (e, layoutView) {
  $("#nf-form-3-cont #nf-field-57").val(document.location.search.replace("?", ""));
});

/*  ==========================================================================
  DEMO DAY - Disclaimer popup
========================================================================== */

function demoDaysDisclaimer() {
  if (document.querySelector(".disclaimer")) {
    body.classList.add("disclaimer-displayed");
  }
}
demoDaysDisclaimer();

function checkDisclaimerCookie() {
  let demodayID = php_variables.demo_day.ID;
  // Check for company URL
  let url = new URL(window.location.href);
  if (url.searchParams.has("disclaimer")) {
    // set cookie to store disclaimer acceptance
    setCookie("disclaimer_" + demodayID, true, 7);
    // delete from url
    url.searchParams.delete("disclaimer");
    let newurl = url.toString();
    // update URL to remove discalimer query param
    window.history.pushState({}, "", newurl);
    document.querySelector(".disclaimer").remove();
    body.classList.remove("disclaimer-displayed");
  }
}

checkDisclaimerCookie();

/*  ==========================================================================
  DEMO DAY - Stop users being able to submit multiple times. 
========================================================================== */

// Add current url to hidden field in access form
jQuery(document).ready(function () {
  jQuery(document).on("nfFormSubmitResponse", function (event) {
    document.querySelector(".btn--submit").disabled = true;
    document.querySelector(".btn--submit").addClass("btn--disabled");
  });
});

